import { createSelector } from '@reduxjs/toolkit';
import selfSelector from './self';

const loadingSelector = createSelector(selfSelector, (rejectsReport) => rejectsReport.loading);

export default loadingSelector;
